/**
 * May types user can toggle within...
 */
export enum MapType {
    Standard = 0,
    Grayscale = 1,
    Dark = 2,
    Satellite = 3,
    SatelliteWithLabels = 4,
}